import { render, staticRenderFns } from "./shop-channel-icon.vue?vue&type=template&id=c8491e68"
import script from "./shop-channel-icon.vue?vue&type=script&lang=js"
export * from "./shop-channel-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports